import { Component, input } from '@angular/core';

@Component({
    selector: 'message-status',
    templateUrl: './message-status.component.html',
    standalone: false
})
export class MessageStatusComponent {
    public isMessagePending = input<boolean>(false);
}
